import { FC } from 'react'
import ScreenHeader from './ScreenHeader'
import { AssessmentTest } from '@app/models'

export interface ScreenProps {
  headerIcon?: JSX.Element
  children?: React.ReactNode
  test?: AssessmentTest
  previewMode?: boolean
}

const ScreenComponent: FC<ScreenProps> = ({ children, headerIcon, test, previewMode }) => {
  return (
    <>
      <ScreenHeader icon={headerIcon} test={test} previewMode={previewMode} />
      {children}
    </>
  )
}

export default ScreenComponent
